import { createSlice } from '@reduxjs/toolkit';

const LOCAL_STORAGE_KEY = 'itemGridPreferences';

const defaultState = {};

function loadState() {
  try {
    const serialized = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!serialized) return defaultState;
    return { ...defaultState, ...JSON.parse(serialized) };
  } catch {
    return defaultState;
  }
}

function saveState(state) {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
  } catch {}
}

const itemGridPreferencesSlice = createSlice({
  name: 'itemGridPreferences',
  initialState: loadState(),
  reducers: {
    setVisibleColumns(state, action) {
      const { pageKey, columns } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].visibleColumns = columns;
      saveState(state);
    },
    setSortOrder(state, action) {
      const { pageKey, sortOrder } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].sortOrder = sortOrder;
      saveState(state);
    },
    setSortBy(state, action) {
      const { pageKey, sortBy } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].sortBy = sortBy;
      saveState(state);
    },
    setFilterField(state, action) {
      const { pageKey, field, value } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey][field] = value;
      saveState(state);
    },
    resetPreferences(state, action) {
      const { pageKey } = action.payload || {};
      if (pageKey) {
        delete state[pageKey];
      } else {
        Object.keys(state).forEach(key => delete state[key]);
      }
      saveState(state);
    },
  },
});

export const { setVisibleColumns, setSortOrder, setSortBy, setFilterField, resetPreferences } = itemGridPreferencesSlice.actions;
export default itemGridPreferencesSlice.reducer; 